import React from "react";
import { Row, Col } from "react-bootstrap";
import styled from "styled-components";
const Wrapper = styled.div`
  width: 100%;
  background: #195732;
  position: relative;

  .mainContainer {
    height: 100%;
  }
  .image {
    width: 100%;
  }
  .title {
    font-size: 110px;
    color: #fff;
    letter-spacing: -4px;
    margin: 0;
    line-height: 0.99;
    font-weight: 700;
    text-align: center;
    padding-bottom: 25px;
  }

  .textContainer {
    height: 100%;
  }
  .teamContainer {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 25px;
    max-width: 480px;
  }
  .name {
    font-weight: bold;
    font-size: 16px;
    color: #fff;
  }
  .position {
    color: #fff;
  }
  .teamImage {
    border-radius: 50%;
    width: 100%;
  }

  @media only screen and (max-width: 1399px) {
    .textContainer {
      height: 100%;
    }
    .title {
      font-size: 85px;
    }
    .teamContainer {
      grid-gap: 15px;
    }
    .teamImage {
      width: 75%;
    }
  }
  @media only screen and (max-width: 1199px) {
    .textContainer {
      height: 100%;
    }
    .title {
      padding-bottom: 15px;
      font-size: 75px;
    }
  }
  @media only screen and (max-width: 1014px) {
    .teamImage {
      width: 65%;
    }
    .name {
      font-size: 14px;
    }
    .position {
      font-size: 14px;
    }
  }
  @media only screen and (max-width: 991px) {
    .textContainer {
      height: 100%;
    }
    .teamContainer {
      grid-gap: 35px;
    }
    .mainContainer {
      background: #000;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 60px 15px;
    }
    .title {
      font-size: 70px;
      padding-bottom: 45px;
    }

    .teamImage {
      width: 100%;
    }
  }
  @media only screen and (max-width: 575px) {
    .teamContainer {
      grid-template-columns: 1fr 1fr;
      grid-gap: 35px;
    }
  }
  @media only screen and (max-width: 520px) {
    .title {
      font-size: 50px;
    }
  }
`;
const OurTeam = () => {
  const data = [
    {
      img: "./images/8.png",
      name: "Markel",
      position: "Founder",
    },
    {
      img: "./images/9.png",
      name: "Jeura",
      position: "Developers",
    },
    {
      img: "./images/5.png",
      name: "Kurami",
      position: "Consulting",
    },
    {
      img: "./images/11.png",
      name: "Mirado",
      position: "3D",
    },
    {
      img: "./images/1.png",
      name: "Seth",
      position: " 2D",
    },
    {
      img: "./images/12.png",
      name: "Jackal",
      position: " IT & Technology",
    },
  ];
  return (
    <Wrapper>
      <Row className="align-items-center pt-5">
        <Col lg={6} xl={5} xxl={5} className="mx-auto mainContainer ">
          <div className="textContainer d-flex justify-content-center align-items-center">
            <div className="d-flex flex-column align-items-center">
              {" "}
              <h1 className="title">Our Team</h1>
              <div className="teamContainer">
                {data.map((el, i) => (
                  <div
                    key={i}
                    className="d-flex justify-content-center flex-column align-items-center py-xl-2"
                  >
                    <img src={el.img} alt="#" className="teamImage" />
                    <p className="name">{el.name}</p>
                    <p className="position">{el.position}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Col>
        <Col lg={6} xl={5}>
          {" "}
          <img src="./images/7.png" alt="#" className="image" />
        </Col>
      </Row>
    </Wrapper>
  );
};
export default OurTeam;
